import { BackIcon, EditIconBlue, NavCloseIcon } from 'assets/icons';
import { FC, useState } from 'react';
import { EstimateStatus } from '../constants'; // Adjust import based on your constants file
import { getStatusColor, getStatusText } from '../utils';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';

interface EditEstimateStatusDetailPanelProps {
  status: EstimateStatus; // Adjust type based on your estimate status
  onBackClick: () => void;
  onSave: (note: string) => void;
  isRootState?: boolean;
  isActionInProgress?: boolean;
}

const EditEstimateStatusDetailPanel: FC<EditEstimateStatusDetailPanelProps> = ({
  status,
  onBackClick,
  onSave,
  isRootState = false,
  isActionInProgress = false
}) => {
  const [statusNote, setStatusNote] = useState('');

  const handleSave = () => {
    onSave(statusNote);
  };

  return (
    <div className="h-full w-96">
      <div className="flex items-center border-b border-secondaryBtn py-4">
        <div onClick={onBackClick} className="mx-4 cursor-pointer">
          {isRootState ? (
            <NavCloseIcon id="estimate-details-panel-close" />
          ) : (
            <BackIcon id="estimate-details-panel-back-arrow" />
          )}
        </div>
        <div className="text-17px font-semibold text-headingGray">Status</div>
      </div>
      <div className="my-6 px-4">
        <div className="mt-6">
          <div className="mb-2 text-sbase font-bold text-primaryText">Status</div>
          <div className="flex items-center justify-between rounded-md border border-borderGray p-4">
            <div className="flex items-center gap-x-2">
              <div className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: getStatusColor(status) }} />
              <div className="text-sbase" style={{ color: getStatusColor(status) }}>
                {getStatusText(status)}
              </div>
            </div>
            {!isRootState && (
              <EditIconBlue className="h-[18px] w-[18px] shrink-0 cursor-pointer" onClick={onBackClick} />
            )}
          </div>
        </div>
        <div className="mt-5">
          <div className="mb-2 text-sbase font-bold text-primaryText">Add note</div>
          <CustomTextArea
            id="edit-estimate-note"
            name="edit-estimate-note"
            className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-medium 
                    text-primaryText focus:outline-none"
            value={statusNote}
            onChange={setStatusNote}
            showRemainingChar={true}
            maxLength={1000}
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4 pt-0">
        <CustomButton
          id="edit-estimate-save-button"
          className="w-full"
          onClick={handleSave}
          isLoading={isActionInProgress}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-estimate-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditEstimateStatusDetailPanel;
